<div class="shopping-cart-preview">
  <div class="d-flex p-2 align-items-center">
    <div>{{ cartItemCount | i18nPlural: i18nShoppingCartPreviewCartInfo }}</div>

    <a class="btn btn-primary ms-auto" [routerLink]="['shopping-cart']" data-bs-dismiss="offcanvas">
      <span i18n="@@CartPreviewGoToCartButton">Go to cart</span>
      <i class="bi bi-cart4 ms-2"></i>
    </a>
  </div>

  @if (cartItemCount > 0) {
    <hr class="my-3 light" />

    @for (cartPreviewItem of cartPreviewItemList; track cartPreviewItem; let odd = $odd) {
      <app-cart-preview-item [cartPreviewItem]="cartPreviewItem" class="d-inline-block w-100" [class.odd]="odd"> </app-cart-preview-item>

      <hr class="my-3 light" />
    }

    @if (cartPreviewDisplayTotalPrice) {
      <div class="d-flex mb-summary-price-total mt-auto p-3">
        <span i18n="@@SummaryPriceTotalLabel">Total price:</span>
        <span class="me-auto"></span>

        <div class="price-summary">
          @if (shouldLoadPrices) {
            <app-price-simple [price]="totalPrice"></app-price-simple>
          } @else {
            <app-price-missing-info-icon></app-price-missing-info-icon>
          }
        </div>
      </div>
    }
  }
</div>
